import type { FunctionComponent } from "react";

import { CountryCellContent } from "app/components/React/Table/cells/CountryCellContent";

interface ILocationCellProps {
    value: {
        countryCode: number;
        text: string;
    };
}

export const LocationCell: FunctionComponent<ILocationCellProps> = ({ value }) => {
    const { countryCode, text } = value;

    return (
        <div className="swTable-countryCell">
            <CountryCellContent
                countryCode={countryCode}
                text={text}
            />
        </div>
    );
};
LocationCell.displayName = "LocationCell";
